import React from 'react';
import { mockData } from '../mock';
import Header from './Header';
import HeroSlider from './HeroSlider';
import ContactSection from './ContactSection';
import EosExperienceSections from './EosExperienceSections';
import { Separator } from './ui/separator';
import { Link } from 'react-router-dom';

const Homepage = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="min-h-screen bg-white eos-experience-page">
      <Header scrollToSection={scrollToSection} />

      <HeroSlider
        scrollToSection={scrollToSection}
        company={mockData.company}
        slides={mockData.heroSlides}
      />

      <EosExperienceSections scrollToSection={scrollToSection} />

      <ContactSection contact={mockData.contact} />

      <footer className="bg-eos-grauDunkel text-eos-weißFast">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <Link
                to="/z-intern-394"
                aria-label="Interner Bereich"
                className="inline-block"
              >
                <div className="h-20 w-48 bg-logo_hell bg-contain bg-no-repeat bg-left" />
              </Link>
              <p className="mt-4 text-sm text-eos-weißFast/65">
                Planung und Umsetzung elektrotechnischer Anlagen. Durchdacht
                konzipiert. Dauerhaft betrieben.
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold tracking-wide">Leistungen</h4>
              <ul className="mt-4 space-y-2 text-sm text-eos-weißFast/65">
                <li>Elektrotechnik</li>
                <li>Photovoltaik</li>
                <li>Speicher & Energiemanagement</li>
                <li>Sicherheitstechnik</li>
                <li>Betrieb & Service</li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold tracking-wide">Navigation</h4>
              <ul className="mt-4 space-y-2 text-sm text-eos-weißFast/65">
                <li><button className="hover:text-eos-weißFast" onClick={() => scrollToSection('features')}>System</button></li>
                <li><button className="hover:text-eos-weißFast" onClick={() => scrollToSection('projects')}>Referenzen</button></li>
                <li><button className="hover:text-eos-weißFast" onClick={() => scrollToSection('about')}>Über uns</button></li>
                <li><button className="hover:text-eos-weißFast" onClick={() => scrollToSection('contact')}>Kontakt</button></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold tracking-wide">Kontakt</h4>
              <div className="mt-4 space-y-2 text-sm text-eos-weißFast/65">
                <p>{mockData.contact.address}</p>
                <p>{mockData.contact.phone}</p>
                <p>{mockData.contact.email}</p>
              </div>
            </div>
          </div>

          <Separator className="my-8 bg-white/10" />

          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-eos-weißFast/55">
              © {new Date().getFullYear()} {mockData.company.name}. Alle Rechte vorbehalten.
            </p>
            <div className="flex gap-6 text-sm text-eos-weißFast/65">
              <Link to="/impressum" className="hover:text-eos-weißFast">Impressum</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Homepage;
